export class ChecklistListItemEntity {
  constructor(
    readonly id: string,
    readonly caseTypeId: string,
    readonly caseTypeName: string,
    readonly stepCount: number,
    readonly displayOnCases: boolean,
    readonly updatedOn: string,
  ) {}
}
